import "./request.resource";

class AuthRequestDataService {
    public static $inject: string[] = [
        "authRequestResource"
    ];

    private authRequestResource;

    constructor(
        authRequestResource
    ) {
        this.authRequestResource = authRequestResource;
    }

    public create(data) {
        return this.authRequestResource().create(data).$promise;
    }

    public authorize(data) {
        return this.authRequestResource().authorize(data).$promise;
    }

    public refuse(data) {
        return this.authRequestResource().refuse(data).$promise;
    }

    public query() {
        return this.authRequestResource().query().$promise;
    }

    public getStatus(uuid) {
        return this.authRequestResource().getStatus({ id: uuid }).$promise;
    }
}

angular
    .module("thor.core.auth.request-data-service", [
        "thor.core.auth.request.resource"
    ])
    .service("authRequestDataService", AuthRequestDataService);
